import { Button, Divider, IconButton, Modal, TextField } from "@mui/material";
import { alpha, Box } from "@mui/system";
import AnswerComponent from "../answerComponent";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";
import CustomizedSteppers from "../customStepper";
import { useState } from "react";
import AvaliacaoComponent from "../avaliacaoComponent";
export default function ModalAnswerComponent(params) {
  const {
    open,
    handleClose,
    newForm,
    setNewForm,
    error,
    setError,
    createForm,
    handleAddQuestion,
    handleRemoveQuestion,
    containerRef,
    lastItemRef,
    handleQuestionChange,
    stepsName = [],
    setSnackbar = () => {},
    setStep = () => {},
    step = 0,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const validationForm = () => {
    if (!newForm?.title?.trim()) {
      setError(true);
      setSnackbar({
        children: "Por favor, preencha o título.",
        severity: "warning",
      });
      return;
    }
    if (newForm?.questions.some((q) => !q?.question?.trim())) {
      setError(true);
      setSnackbar({
        children: "Não é permitido perguntas em branco.",
        severity: "warning",
      });
      return;
    }
    if (newForm?.questions.some((q) => q?.type === 2 && !q?.options?.length)) {
      setError(true);
      setSnackbar({
        children: "Necessário adicionar opções para perguntas de seleção.",
        severity: "warning",
      });
      return;
    }
    setStep(step + 1);
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Box sx={styles.boxModal}>
        <CustomizedSteppers stepNumber={step} steps={stepsName} />
        {step === 0 && (
          <Box>
            <Box sx={styles.boxTitle}>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                variant="filled"
                autoComplete="off"
                value={newForm?.title || ""}
                label={"Título do formulário"}
                error={!newForm?.title?.trim() && error}
                helperText={
                  !newForm?.title?.trim() && error ? "Título é obrigatório" : ""
                }
                onChange={(event) =>
                  setNewForm((prev) => ({ ...prev, title: event.target.value }))
                }
              />
            </Box>

            <Box sx={styles.boxMainPerguntas}>
              <Box sx={styles.boxPerguntas} ref={containerRef}>
                {newForm?.questions?.map((question, index) => (
                  <Box
                    key={question?.id}
                    ref={
                      index === newForm?.questions?.length - 1
                        ? lastItemRef
                        : null
                    }
                    sx={styles.boxAnswer}
                  >
                    <AnswerComponent
                      id={question?.id}
                      question={question}
                      position={index}
                      error={error}
                      handleQuestionChange={handleQuestionChange}
                    />
                    <Box sx={styles.containerButtonIcons}>
                      {newForm?.questions?.length > 1 && (
                        <>
                          <IconButton
                            onClick={() => handleRemoveQuestion(question.id)}
                          >
                            <DeleteOutlineOutlined color="error" />
                          </IconButton>
                        </>
                      )}
                    </Box>
                  </Box>
                ))}
                <Box sx={styles.containerButtonNewPergunta}>
                  <Button onClick={handleAddQuestion} variant="contained">
                    Nova pergunta
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {step === 1 && (
          <Box sx={styles.conatinerPreVisualizacao}>
            <AvaliacaoComponent questions={newForm?.questions} />
          </Box>
        )}

        <Box sx={styles.containerButton}>
          {step !== 0 && (
            <Box sx={{ width: "100%" }}>
              {" "}
              <Button
                onClick={() => {
                  setStep(step - 1);
                }}
                variant="outlined"
              >
                Voltar
              </Button>
            </Box>
          )}
          <Button
            onClick={() => {
              handleClose();
            }}
            variant="outlined"
          >
            Cancelar
          </Button>
          {step === 1 ? (
            <Button
              onClick={() => {
                createForm();
              }}
              variant="contained"
            >
              Salvar
            </Button>
          ) : (
            <Button
              onClick={() => {
                validationForm();
              }}
              variant="contained"
            >
              Próximo
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
